import React from 'react';
import { LinkButton } from '@/components/ui/Buttons';
import Text from '@/components/ui/Text';
import showToast, { dismissToast } from '@/components/common/Toast';
import I18n from '@/modules/i18n';

const TOAST_DURATION = 8000;

interface ActionToastProps {
  message: string;
  onUndo: () => void;
}

const ActionToast = ({ message, onUndo }: ActionToastProps) => (
  <span className="tw-flex tw-items-center tw-gap-3">
    <Text size="sm" tag="span">{message}</Text>
    <LinkButton onClick={onUndo}>{I18n.t('undo')}</LinkButton>
  </span>
);

interface UndoToastParams {
  announcement: string;
  message: string;
  onUndo: () => void;
  toastId: string;
}

export default function showUndoToast({
  announcement, message, onUndo, toastId,
}: UndoToastParams) {
  const undo = () => {
    dismissToast(toastId);
    onUndo();
  };

  // `circle` is the compact single-row icon style. The default `square` one puts a full-height
  // coloured block down the left edge and floats the ✕ into the corner.
  showToast(<ActionToast message={message} onUndo={undo} />, {
    announcement,
    autoClose: TOAST_DURATION,
    closeOnClick: false,
    iconStyle: 'circle',
    msgType: 'info',
    position: 'bottom-right',
    toastId,
  });
}
